import CustomHead from 'components/commons/CustomHead'
import Template from 'components/LP/LP202407/Thanks'
import useLocalStorage from 'hooks/useLocalStorage'

const Thanks: React.FC = () => {
  const fromCorrectFormPage = useLocalStorage('refCircleCiLpContactPage')
  return (
    <>
      {fromCorrectFormPage ? (
        <CustomHead
          keyword={'CircleCI CI/CD パイプライン ビルド 自動デプロイ'}
          image={'https://aitria.co.jp/img/ogp_logo.png'}
          url={'https://aitria.co.jp/services/circleci/thanks/'}
          title="送信完了 CircleCI | サービス | Aitria（アイトリア）"
          description="CircleCI導入支援で、CI/CDパイプラインを効率化。クラウド環境での高速ビルド、自動デプロイ、並列テスト実行を実現し、開発の迅速化をサポートします。"
        />
      ) : (
        <></>
      )}
      <Template />
    </>
  )
}

export default Thanks
